function e(t) {
  return t != null && typeof t == "object";
}
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/isObjectLike.js
// module id = 118
// module chunks = 41